const { escapeRegExp } = require('@sigma-legacy-libs/no-lodash')
const StringParser = require('./StringParser')

const tags = [
  [ [ 'ВСЕ', 'EVERYTHING' ], '.*' ],
  [ [ 'ЦИФРЫ', 'Ц', 'DIGITS', 'D' ], '\\d+?' ],
  [ [ 'БУКВЫ', 'Б', 'LETTERS', 'L' ], '[А-яЁё\\wÀ-ÿ]+?' ],
  [ [ 'БУКВЫЦИФРЫ', 'БЦ', 'LETTERSDIGITS', 'LD' ], '[А-яЁё\\wÀ-ÿ\\d]+?' ],
  [ [ 'БУКВЫПРОБЕЛЫ', 'БП', 'LETTERSSPACES', 'LS' ], '[А-яЁё\\wÀ-ÿ\\s]+?' ],
  [ [ 'БУКВЫЦИФРЫПРОБЕЛЫ', 'БЦП', 'LETTERSDIGITSSPACES', 'LDS' ], '[А-яЁё\\wÀ-ÿ\\d\\s]+?' ],
  [ [ 'РУССКИЕБУКВЫ', 'РБ', 'RULETTERS', 'RL' ], '[А-яЁё]+?' ],
  [ [ 'РУССКИЕБУКВЫЦИФРЫ', 'РБЦ', 'RULETTERSDIGITS', 'RLD' ], '[А-яЁё\\d]+?' ],
  [ [ 'РУССКИЕБУКВЫПРОБЕЛЫ', 'РБП', 'RULETTERSSPACES', 'RLS' ], '[А-яЁё\\s]+?' ],
  [ [ 'РУССКИЕБУКВЫЦИФРЫПРОБЕЛЫ', 'РБЦП', 'RULETTERSDIGITSSPACES', 'RLDS' ], '[А-яЁё\\d\\s]+?' ]
].reduce((result, tag) => {
  if (!tag[1] || typeof tag[1] !== 'string') {
    return result
  }

  if (typeof tag[0] === 'string') {
    tag[0] = [ tag[0] ]
  }
  if (Array.isArray(tag[0])) {
    tag[0].forEach(t => {
      Object.assign(result, {
        [t.toLowerCase()]: tag[1]
      })
    })
  }

  return result
}, {})

const stringParser = new StringParser([
  {
    match: '([a-z]+://[^\\s]+)',
    handler: part => escapeRegExp(part)
  },
  {
    match: '/((?![*+?])(?:[^\\r\\n\\[/\\\\]|\\\\.|\\[(?:[^\\r\\n\\]\\\\]|\\\\.)*\\])+)\\/((?:g(?:im?|mi?)?|i(?:gm?|mg?)?|m(?:gi?|ig?)?)?)',
    handler: (part, match) => match[1]
  },
  {
    match: '#([A-zА-я_]+)#',
    handler: (part, match) => tags[match[1].toLowerCase()] || ''
  },
  {
    match: '(\\s+(\\r\\n|\\r|\\n))',
    handler: () => '\\s*?\\r?\\n'
  }
])

exports.stringParser = stringParser

exports.generateRegExpFromString = string => stringParser.makeRegExp(string)

const regexpMath = /^(?:\/(.*)\/([a-z]*)|(.*))$/
exports.parseRegexp = (string, options = {}) => {
  const allowedFlags = options.allowedFlags || [ 'g', 'i' ]
  if (typeof string === 'string') {
    const m = string.match(regexpMath)
    const pattern = m[1] || m[3]
    const flags = ('' + (m[2] || '') + (options.flags || ''))
      .split('')
      .filter((item, i, ar) => ar.indexOf(item) === i && ~allowedFlags.indexOf(item))
      .join('')

    return {
      regex: new RegExp(pattern, flags),
      pattern,
      flags
    }
  }

  return string
}

function convertPatternToRegexp(pattern) {
  return new RegExp('^' +
      escapeRegExp(pattern)
        .replace(/\\?\*\\?\*/g, '.+?')
        .replace(/\\?\*/g, '[^\\/]+?') +
      '\\/?$')
}
exports.convertPatternToRegexp = convertPatternToRegexp

const REGEX_CONTENT_IN_ROUND_BRACKETS = new RegExp(/^\^?\((.*?)\)\$?$/)
const REGEX_GROUP_BY_SLASH = new RegExp(/(.*?)([^\\]\||$)/, 'g')
const REGEX_GROUP_BY_SEP = new RegExp(/(.*?)\|?$/)
const REGEX_ESCAPED_SPECIAL_SYMBOLS = new RegExp(/\\([\\^$.*+?()[\]{}|])/, 'g')

function splitRegExpStringToArray(regexpString) {
  const array = []
  const matches = regexpString.replace(REGEX_CONTENT_IN_ROUND_BRACKETS, '$1').match(REGEX_GROUP_BY_SLASH)
  if (Array.isArray(matches) && matches.length) {
    for (const string of matches) {
      if (string) {
        array.push(string.replace(REGEX_GROUP_BY_SEP, '$1').replace(REGEX_ESCAPED_SPECIAL_SYMBOLS, '$1'))
      }
    }
  }

  return array
}
exports.splitRegExpStringToArray = splitRegExpStringToArray
